import {useState, useMemo, useCallback} from 'react'; 
import type {CalendarEvent} from './useEvents';

function counterpartyId(ev: CalendarEvent, currentUserId?: string | null) {
    if (!currentUserId) return ev.parentId || ev.tutorId;
    return ev.tutorId === currentUserId ? ev.parentId : ev.tutorId;
  }

type Group = {
    id: string; 
    name: string; 
    events: CalendarEvent[];
    next?: CalendarEvent;
    avatar?: {name?: string; photoUrl?: string | null; color?: string | null};
}

type ViewMode = 'date' | 'person';

export function useLessonNavigation(
    groupedList: Group[],
    userId: string | undefined,
) {
    const [view, setView]  = useState<ViewMode>('date');
    const [selectedCounterparty, setSelectedCounterparty] = useState<string | null>(null);
    const [openEvent, setOpenEvent] = useState<CalendarEvent | null>(null);

    const selectedPersonEvents = useMemo(() => {
        if (!selectedCounterparty) return [];
        // Efficiently find the group by ID instead of filtering the whole list again
        const group = groupedList.find(g => g.id === selectedCounterparty);
        return group ? group.events : [];
      }, [groupedList, selectedCounterparty]);

    const avatarForDetailView = useMemo(() => {
        if (!openEvent) return undefined; 
        const cId = counterpartyId(openEvent, userId);
        const group = groupedList.find(g => g.id === cId);

        // 3. Return that group's avatar (or undefined if not found).
        return group?.avatar;
    }, [openEvent, userId, groupedList]); 

    const handleSetView = useCallback((newView: 'date' | 'person') => {
        setView(newView);
        setSelectedCounterparty(null); // Always reset selection when switching tabs
      }, []);

      const handleBack = useCallback(() => {
        setSelectedCounterparty(null);
      }, []);
    
      const handleSelectPerson = useCallback((id: string) => {
        setSelectedCounterparty(id);
      }, []);
    
      const handleCloseModal = useCallback(() => {
        setOpenEvent(null);
      }, []);


    return {
        view, 
        selectedCounterparty, 
        openEvent,
        setOpenEvent, 
        selectedPersonEvents, 
        avatarForDetailView, 

        setView: handleSetView,
        goBack: handleBack,
        selectPerson: handleSelectPerson,
        closeModal: handleCloseModal


    }



}
